import { createSlice } from '@reduxjs/toolkit'

export const modalsSlice = createSlice({
  name: 'modals',
  initialState: {
    pdfViewer: 'close',
    activeDevices: 'close',
    sendOtp: 'close',
    addPayment: 'close',
    robotSmsCredits: 'close',
    organizerSettingsEventFeePercent: 'close',
    downloadReport: 'close',
    organizerSettings: 'close',
    cancelTicket: 'close',
    transactionAction: 'close',
    declineRequestAction: 'close',
    approveRequestAction: 'close',
    eventCrossQRScanner: 'close',
    eventGiftTickets: 'close',
    organizerFiles: 'close',
    uploadOrganizerFile: 'close',
    createTransaction: 'close',
    billAccount: 'close',
  },
  reducers: {
    toggleActiveDevicesModal(state) {
      return { ...state, activeDevices: state.activeDevices === 'open' ? 'close' : 'open' }
    },
    toggleSendOtpModal(state) {
      return { ...state, sendOtp: state.sendOtp === 'open' ? 'close' : 'open' }
    },
    toggleAddPaymentModal(state) {
      return { ...state, addPayment: state.addPayment === 'open' ? 'close' : 'open' }
    },
    togglePdfViewerModal(state) {
      return { ...state, pdfViewer: state.pdfViewer === 'open' ? 'close' : 'open' }
    },
    toggleRobotSmsCreditsModal(state) {
      return { ...state, robotSmsCredits: state.robotSmsCredits === 'open' ? 'close' : 'open' }
    },
    toggleDownloadReportModal(state) {
      return { ...state, downloadReport: state.downloadReport === 'open' ? 'close' : 'open' }
    },
    toggleCancelTicketModal(state) {
      return { ...state, cancelTicket: state.cancelTicket === 'open' ? 'close' : 'open' }
    },
    toggleOrganizerSettingsModal(state) {
      return { ...state, organizerSettings: state.organizerSettings === 'open' ? 'close' : 'open' }
    },
    toggleTransactionActionModal(state) {
      return { ...state, transactionAction: state.transactionAction === 'open' ? 'close' : 'open' }
    },
    toggleDeclineRequestActionModal(state) {
      return { ...state, declineRequestAction: state.declineRequestAction === 'open' ? 'close' : 'open' }
    },
    toggleApproveRequestActionModal(state) {
      return { ...state, approveRequestAction: state.approveRequestAction === 'open' ? 'close' : 'open' }
    },
    toggleEventCrossQRScannerModal(state) {
      return { ...state, eventCrossQRScanner: state.eventCrossQRScanner === 'open' ? 'close' : 'open' }
    },
    toggleEventGiftTicketsModal(state) {
      return { ...state, eventGiftTickets: state.eventGiftTickets === 'open' ? 'close' : 'open' }
    },
    toggleOrganizerSettingsEventFeePercentModal(state) {
      return { ...state, organizerSettingsEventFeePercent: state.organizerSettingsEventFeePercent === 'open' ? 'close' : 'open' }
    },
    toggleOrganizerFilesModal(state) {
      return { ...state, organizerFiles: state.organizerFiles === 'open' ? 'close' : 'open' }
    },
    toggleUploadOrganizerFileModal(state) {
      return { ...state, uploadOrganizerFile: state.uploadOrganizerFile === 'open' ? 'close' : 'open' }
    },
    toggleCreateTransactionModal(state) {
      return { ...state, createTransaction: state.createTransaction === 'open' ? 'close' : 'open' }
    },
    toggleBillAccountModal(state) {
      return { ...state, billAccount: state.billAccount === 'open' ? 'close' : 'open' }
    },
  },
})

export default modalsSlice.reducer
